import React, { useEffect, useState, useCallback } from 'react';
import $ from 'jquery';
import 'datatables.net'; 
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

const MstUjianPendidik = () => {
    const [pembelajaran, setPembelajaran] = useState([]); 
   

    const [formData, setFormData] = useState({
      
        kode_mst_ujian:"", nama_master:"", tgl_mulai:"", tgl_selesai:""

    }); // State untuk menyimpan daftar kelas
    const [isEditing, setIsEditing] = useState(false);


    useEffect(() => { 
       
        if ($.fn.dataTable.isDataTable('.table')) {
            $('.table').DataTable().destroy();
        }
        
        $('.table').DataTable({
            ajax: {
                url: `${process.env.REACT_APP_BASE_URL}/pendidik/getMstTes`,
                type: "GET",
                  headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
                dataSrc: function(json) {
                    console.log(json)
                    if (!json.data || json.data.length === 0) {
                        return []; // Jika data kosong, tetap kembalikan array kosong agar DataTables tetap berfungsi
                    }
                    return json.data;
                }
            },
            columns: [
                { 
                    data: null, 
                    render: function (data, type, row, meta) {
                        return meta.row + 1; // Menampilkan nomor urut
                    }
                },
             
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        const formatTanggal = (tgl) => {
                            const date = new Date(tgl);
                            return date.toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' });
                        };
                        return `<a href="/pendidik/subtes?id=${row.kode_mst_ujian}"><b>${row.nama_master}</b></br><span class="text-muted text-sm d-block">${formatTanggal(row.tgl_mulai)} <i class="ti ti-chevron-right"></i> ${formatTanggal(row.tgl_selesai)}</span></a>`;
                    }
                },
                { 
                    data: null,
                    render: function (data, type, row, meta) {
                        return `<b><a href="/pendidik/subtes?id=${row.kode_mst_ujian}"><b>${row.jumlah_ujian}</b></a>`;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row, meta) {
                     
                
                        return ` <a href="/pendidik/subtes?id=${row.kode_mst_ujian}" class="avtar avtar-xs mx-1 btn-link-secondary"><i class="ti ti-chevron-right f-20"></i> </a>`;
                    }
                },
            ],
            destroy: true,
            dom: "<'row'<'col-6 col-sm-6 col-md-9'f><'col-6 col-sm-6 col-md-2 'B><'col-sm-6 col-md-1 float-right'l>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-10'p><'col-sm-12 col-md-2'i>>",
            language: {
                search: "",
                lengthMenu: "_MENU_",
                emptyTable: "Belum memiliki data", // Pesan jika tidak ada data
                loadingRecords: "Loading....", // Ganti teks "Loading..."
                zeroRecords: "Belum memiliki data yang" // Jika pencarian tidak menemukan hasil
            },
        });
     
        return () => {
            if ($.fn.dataTable.isDataTable('.table')) {
                $('.table').DataTable().destroy();
            }
        };
    }, []);// Inisialisasi ulang hanya ketika `kelas` berubah
   

    useEffect(() => {
        if (formData.id_mapel) {
            // Ambil semua pembelajaran yang sesuai dengan mapel yang dipilih
            const pembelajaranFiltered = pembelajaran?.filter(
                (item) => item.mata_pelajaran_id === formData.id_mapel
            );

            // Ambil semua rombel yang sesuai dengan pembelajaran tersebut
            const rombelIds = pembelajaranFiltered.map((item) => item.mata_pelajaran_id);
            const rombelFiltered = pembelajaran?.filter((rombel) =>
                rombelIds.includes(rombel.mata_pelajaran_id)
            );
            console.log(rombelFiltered)

          
        } 
    }, [formData.id_mapel]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Jika select option yang berubah, simpan juga nama yang dipilih
        if (name === "id_rombel") {
            const selectedRombel =pembelajaran?.find((r) => String(r.rombongan_belajar_id) ===  String(value));
            
            setFormData({
                ...formData,
                id_rombel: value,
                nama_rombel: selectedRombel ? selectedRombel.nama_rombel : "",
                pembelajaran_id: selectedRombel ? selectedRombel.pembelajaran_id : ""
            });
        } else if (name === "id_mapel") {
            const selectedMapel = pembelajaran?.find((m) => String(m.mata_pelajaran_id) ===  String(value));
            setFormData({
                ...formData,
                id_mapel: value,
                nama_mapel: selectedMapel ? selectedMapel.nama_mapel : "",
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        console.log(formData)
        
    };

    // Buka modal untuk edit data
    const handleEdit = (ujian) => {
        setIsEditing(true);
        setFormData(ujian);
        console.log(ujian)
    };


    
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData)

        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refrensi/inputmstujian`, {
                method: "POST",
                 headers: {
          'Content-Type': 'application/json',
          'Authorization': "Bearer " + localStorage.getItem("token")
        },
       
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                throw new Error("Gagal menyimpan data");
            }

            const result = await response.json();
            Swal.fire("Berhasil!", result.message, "success").then(() => {
                $('.table').DataTable().ajax.reload(null, false); // Reload DataTable setelah input sukses
            });

            
        } catch (error) {
             Swal.fire("Error!", error.response?.data?.message || 'Something went wrong', "error");
           
           
        }
    };

   

    return (
        <div>
           
                    <div className="row">
                        <div className="col-xl-12 col-md-12">
                            <div className="card">

                                <div className="card-body">
                                    <div className='row mb-3 align-items-center'>
                                        <div className="col"><small className="text-muted">Refrensi</small><h3>Master Evaluasi / Ujian</h3></div>

                                       
                                    </div>
                                    <hr />
                                   <table className="table table-hover datatable-table">
                                        <thead>
                                            <tr>
                                                <th width="50">#</th>
                                              
                                                <th>Nama</th>
                                                <th >Jumlah Ujian</th>
                                                <th width="50"><center>Lihat</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                           
                                        </tbody>
                                    </table>
                                  
                                </div>
                            </div>
                        </div>
                    </div>

            {/* Modal Input/Edit */}
            <div className="modal fade" id="ujianModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <form onSubmit={handleSubmit} className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {isEditing ? "Edit Master Ujian" : "Tambah Master Ujian"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                        <div className="mb-3">
                                <label className="form-label">Nama</label>
                                <input name='nama_master' className="form-control" type="text" placeholder="Nama" value={formData.nama_master} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Mulai</label>
                                <input name='tgl_mulai' className="form-control" type="date" placeholder="Mulai" value={formData.tgl_mulai} onChange={handleChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Selesai</label>
                                <input name='tgl_selesai' className="form-control" type="date" placeholder="Selesai" value={formData.tgl_selesai} onChange={handleChange} />
                            </div>
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Batal
                            </button>
                            <button type="submit" className="btn btn-primary" data-bs-dismiss="modal">
                                {isEditing ? "Update" : "Simpan"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>


        </div>
    );
};

export default MstUjianPendidik;
